export default "__VITE_ASSET__a8e91a72__"